// extracted by mini-css-extract-plugin
export default {"dropDownAndAudio":"style_dropDownAndAudio__czSij","cardParent":"style_cardParent__XksXw","responsive":"style_responsive__X7eoa","inResponsive":"style_inResponsive__Xhi2J"};